import { render, staticRenderFns } from "./UsersGroupsList.vue?vue&type=template&id=a6c3d19c&scoped=true&"
import script from "./UsersGroupsList.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsList.vue?vue&type=style&index=0&id=a6c3d19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c3d19c",
  null
  
)

export default component.exports